import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  NoSuchElementException679xzhnp5bpj as NoSuchElementException,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  UnsupportedOperationException2tkumpmhredt3 as UnsupportedOperationException,
} from '../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import {
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
} from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { charCodeAt1yspne1d8erbm as charCodeAt } from '../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import {
  toString22rbkbhdb5cl2 as toString,
  Char__toInt_impl_vasixdnyockrdnmht5 as Char__toInt_impl_vasixd,
} from '../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { equals2v6cggk171b6e as equals } from '../../../../kotlin-kotlin-stdlib/kotlin/text/stringsCode.mjs';
import { AbstractMutableSetthfi6jds1k2h as AbstractMutableSet } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/AbstractMutableSet.mjs';
import { AbstractMutableCollections0bg6c40ztuj as AbstractMutableCollection } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/AbstractMutableCollectionJs.mjs';
import {
  MutableEntry12w2i19w0igk5 as MutableEntry,
  Entry2xmjmyutzoq3p as Entry,
  KtMutableMap1kqeifoi36kpz as KtMutableMap,
} from '../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  equals2au1ep9vhcato as equals_0,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  hashCodeq5arwsb9dgti as hashCode,
  toString1pkumu07cwy4m as toString_0,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  fill3hcjvebk42tyx as fill,
  fill2542d4m9l93pn as fill_0,
} from '../../../../kotlin-kotlin-stdlib/kotlin/collections/_ArraysJs.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function advance($this) {
  $l$loop: while ($this.u4n_1 < $this.w4n_1.b4o_1) {
    var idx = $this.w4n_1.a4o_1[$this.u4n_1];
    if (idx >= 0 && !($this.w4n_1.x4n_1[idx] == null))
      break $l$loop;
    $this.u4n_1 = $this.u4n_1 + 1 | 0;
  }
}
var CaseInsensitiveMap$KeySet$iterator$1Class;
function CaseInsensitiveMap$KeySet$iterator$1() {
  if (CaseInsensitiveMap$KeySet$iterator$1Class === VOID) {
    class $ {
      constructor(this$0) {
        this.w4n_1 = this$0;
        this.u4n_1 = 0;
        this.v4n_1 = null;
        advance(this);
      }
      q1() {
        return this.u4n_1 < this.w4n_1.b4o_1;
      }
      r1() {
        if (!this.q1())
          throw NoSuchElementException().t6();
        var idx = this.w4n_1.a4o_1[this.u4n_1];
        this.v4n_1 = ensureNotNull(this.w4n_1.x4n_1[idx]);
        this.u4n_1 = this.u4n_1 + 1 | 0;
        advance(this);
        return ensureNotNull(this.v4n_1);
      }
      p6() {
        var tmp0_elvis_lhs = this.v4n_1;
        var tmp;
        if (tmp0_elvis_lhs == null) {
          throw IllegalStateException().o('next() must be called before remove()');
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var key = tmp;
        this.w4n_1.f4o(key);
        this.v4n_1 = null;
      }
    }
    initMetadataForClass($);
    CaseInsensitiveMap$KeySet$iterator$1Class = $;
  }
  return CaseInsensitiveMap$KeySet$iterator$1Class;
}
function advance_0($this) {
  $l$loop: while ($this.g4o_1 < $this.i4o_1.b4o_1) {
    var idx = $this.i4o_1.a4o_1[$this.g4o_1];
    if (idx >= 0 && !($this.i4o_1.x4n_1[idx] == null))
      break $l$loop;
    $this.g4o_1 = $this.g4o_1 + 1 | 0;
  }
}
var CaseInsensitiveMap$ValueCollection$iterator$1Class;
function CaseInsensitiveMap$ValueCollection$iterator$1() {
  if (CaseInsensitiveMap$ValueCollection$iterator$1Class === VOID) {
    class $ {
      constructor(this$0) {
        this.i4o_1 = this$0;
        this.g4o_1 = 0;
        this.h4o_1 = null;
        advance_0(this);
      }
      q1() {
        return this.g4o_1 < this.i4o_1.b4o_1;
      }
      r1() {
        if (!this.q1())
          throw NoSuchElementException().t6();
        var idx = this.i4o_1.a4o_1[this.g4o_1];
        this.h4o_1 = ensureNotNull(this.i4o_1.x4n_1[idx]);
        var tmp = this.i4o_1.y4n_1[idx];
        var result = !(tmp == null) ? tmp : THROW_CCE();
        this.g4o_1 = this.g4o_1 + 1 | 0;
        advance_0(this);
        return result;
      }
      p6() {
        var tmp0_elvis_lhs = this.h4o_1;
        var tmp;
        if (tmp0_elvis_lhs == null) {
          throw IllegalStateException().o('next() must be called before remove()');
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var key = tmp;
        this.i4o_1.f4o(key);
        this.h4o_1 = null;
      }
    }
    initMetadataForClass($);
    CaseInsensitiveMap$ValueCollection$iterator$1Class = $;
  }
  return CaseInsensitiveMap$ValueCollection$iterator$1Class;
}
function advance_1($this) {
  $l$loop: while ($this.j4o_1 < $this.l4o_1.b4o_1) {
    var idx = $this.l4o_1.a4o_1[$this.j4o_1];
    if (idx >= 0 && !($this.l4o_1.x4n_1[idx] == null))
      break $l$loop;
    $this.j4o_1 = $this.j4o_1 + 1 | 0;
  }
}
var CaseInsensitiveMap$EntrySet$iterator$1Class;
function CaseInsensitiveMap$EntrySet$iterator$1() {
  if (CaseInsensitiveMap$EntrySet$iterator$1Class === VOID) {
    class $ {
      constructor(this$0) {
        this.l4o_1 = this$0;
        this.j4o_1 = 0;
        this.k4o_1 = null;
        advance_1(this);
      }
      q1() {
        return this.j4o_1 < this.l4o_1.b4o_1;
      }
      r1() {
        if (!this.q1())
          throw NoSuchElementException().t6();
        var idx = this.l4o_1.a4o_1[this.j4o_1];
        this.k4o_1 = ensureNotNull(this.l4o_1.x4n_1[idx]);
        var tmp = ensureNotNull(this.k4o_1);
        var tmp_0 = this.l4o_1.y4n_1[idx];
        var entry = new (MapEntry())(this.l4o_1, tmp, !(tmp_0 == null) ? tmp_0 : THROW_CCE());
        this.j4o_1 = this.j4o_1 + 1 | 0;
        advance_1(this);
        return entry;
      }
      p6() {
        var tmp0_elvis_lhs = this.k4o_1;
        var tmp;
        if (tmp0_elvis_lhs == null) {
          throw IllegalStateException().o('next() must be called before remove()');
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var key = tmp;
        this.l4o_1.f4o(key);
        this.k4o_1 = null;
      }
    }
    initMetadataForClass($);
    CaseInsensitiveMap$EntrySet$iterator$1Class = $;
  }
  return CaseInsensitiveMap$EntrySet$iterator$1Class;
}
function caseInsensitiveHashCode($this, s) {
  var h = 0;
  var inductionVariable = 0;
  var last = s.length;
  if (inductionVariable < last)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var tmp = imul(31, h);
      // Inline function 'kotlin.text.lowercaseChar' call
      // Inline function 'kotlin.text.lowercase' call
      var this_0 = charCodeAt(s, i);
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.js.unsafeCast' call
      var tmp$ret$1 = toString(this_0).toLowerCase();
      // Inline function 'kotlin.code' call
      var this_1 = charCodeAt(tmp$ret$1, 0);
      h = tmp + Char__toInt_impl_vasixd(this_1) | 0;
    }
     while (inductionVariable < last);
  return h;
}
function putWithoutTrackingOrderReturnIndex($this, key, value) {
  var hash = caseInsensitiveHashCode(Companion_getInstance(), key);
  var index = hash & ($this.x4n_1.length - 1 | 0);
  while (true) {
    var existingKey = $this.x4n_1[index];
    if (existingKey == null) {
      $this.x4n_1[index] = key;
      $this.y4n_1[index] = value;
      $this.z4n_1 = $this.z4n_1 + 1 | 0;
      return index;
    }
    if (equals(existingKey, key, true)) {
      $this.y4n_1[index] = value;
      return index;
    }
    index = (index + 1 | 0) & ($this.x4n_1.length - 1 | 0);
  }
}
function findIndex($this, key) {
  if ($this.z4n_1 === 0)
    return -1;
  var hash = caseInsensitiveHashCode(Companion_getInstance(), key);
  var index = hash & ($this.x4n_1.length - 1 | 0);
  while (true) {
    var existingKey = $this.x4n_1[index];
    if (existingKey == null)
      return -1;
    if (equals(existingKey, key, true))
      return index;
    index = (index + 1 | 0) & ($this.x4n_1.length - 1 | 0);
  }
}
function ensureCapacity($this) {
  if (imul($this.z4n_1, 4) >= imul($this.x4n_1.length, 3)) {
    resize($this, imul($this.x4n_1.length, 2));
  }
}
function resize($this, newCapacity) {
  var oldKeys = $this.x4n_1;
  var oldValues = $this.y4n_1;
  var oldInsertionOrder = $this.a4o_1;
  var oldInsertionCount = $this.b4o_1;
  var tmp = $this;
  // Inline function 'kotlin.arrayOfNulls' call
  tmp.x4n_1 = Array(newCapacity);
  var tmp_0 = $this;
  // Inline function 'kotlin.arrayOfNulls' call
  tmp_0.y4n_1 = Array(newCapacity);
  var tmp_1 = $this;
  var tmp_2 = 0;
  var tmp_3 = new Int32Array(newCapacity);
  while (tmp_2 < newCapacity) {
    tmp_3[tmp_2] = -1;
    tmp_2 = tmp_2 + 1 | 0;
  }
  tmp_1.a4o_1 = tmp_3;
  $this.z4n_1 = 0;
  $this.b4o_1 = 0;
  var inductionVariable = 0;
  if (inductionVariable < oldInsertionCount)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var oldIndex = oldInsertionOrder[i];
      if (oldIndex >= 0 && !(oldKeys[oldIndex] == null)) {
        var tmp_4 = ensureNotNull(oldKeys[oldIndex]);
        var tmp_5 = oldValues[oldIndex];
        $this.m4o(tmp_4, !(tmp_5 == null) ? tmp_5 : THROW_CCE());
      }
    }
     while (inductionVariable < oldInsertionCount);
}
function compactInsertionOrder($this) {
  if ($this.b4o_1 === 0)
    return Unit_instance;
  var writeIndex = 0;
  var inductionVariable = 0;
  var last = $this.b4o_1;
  if (inductionVariable < last)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var idx = $this.a4o_1[i];
      if (idx >= 0 && !($this.x4n_1[idx] == null)) {
        var tmp = $this.a4o_1;
        var _unary__edvuaz = writeIndex;
        writeIndex = _unary__edvuaz + 1 | 0;
        tmp[_unary__edvuaz] = idx;
      }
    }
     while (inductionVariable < last);
  var inductionVariable_0 = writeIndex;
  var last_0 = $this.a4o_1.length;
  if (inductionVariable_0 < last_0)
    do {
      var i_0 = inductionVariable_0;
      inductionVariable_0 = inductionVariable_0 + 1 | 0;
      $this.a4o_1[i_0] = -1;
    }
     while (inductionVariable_0 < last_0);
  $this.b4o_1 = writeIndex;
}
var KeySetClass;
function KeySet() {
  if (KeySetClass === VOID) {
    class $ extends AbstractMutableSet() {
      static o4o($outer, $box) {
        if ($box === VOID)
          $box = {};
        $box.n4o_1 = $outer;
        return this.b8($box);
      }
      q2() {
        return this.n4o_1.z4n_1;
      }
      p4o(element) {
        throw UnsupportedOperationException().a1('CaseInsensitiveMap.keys does not support add');
      }
      i2(element) {
        return this.p4o((!(element == null) ? typeof element === 'string' : false) ? element : THROW_CCE());
      }
      q4o(element) {
        return this.n4o_1.u2o(element);
      }
      t2(element) {
        if (!(!(element == null) ? typeof element === 'string' : false))
          return false;
        return this.q4o((!(element == null) ? typeof element === 'string' : false) ? element : THROW_CCE());
      }
      p1() {
        return new (CaseInsensitiveMap$KeySet$iterator$1())(this.n4o_1);
      }
    }
    initMetadataForClass($, 'KeySet');
    KeySetClass = $;
  }
  return KeySetClass;
}
var ValueCollectionClass;
function ValueCollection() {
  if (ValueCollectionClass === VOID) {
    class $ extends AbstractMutableCollection() {
      static s4o($outer, $box) {
        if ($box === VOID)
          $box = {};
        $box.r4o_1 = $outer;
        return this.m6($box);
      }
      q2() {
        return this.r4o_1.z4n_1;
      }
      t4o(element) {
        throw UnsupportedOperationException().a1('CaseInsensitiveMap.values does not support add');
      }
      i2(element) {
        return this.t4o(!(element == null) ? element : THROW_CCE());
      }
      p1() {
        return new (CaseInsensitiveMap$ValueCollection$iterator$1())(this.r4o_1);
      }
    }
    initMetadataForClass($, 'ValueCollection');
    ValueCollectionClass = $;
  }
  return ValueCollectionClass;
}
var EntrySetClass;
function EntrySet() {
  if (EntrySetClass === VOID) {
    class $ extends AbstractMutableSet() {
      static v4o($outer, $box) {
        if ($box === VOID)
          $box = {};
        $box.u4o_1 = $outer;
        return this.b8($box);
      }
      q2() {
        return this.u4o_1.z4n_1;
      }
      w4o(element) {
        throw UnsupportedOperationException().a1('CaseInsensitiveMap.entries does not support add');
      }
      i2(element) {
        return this.w4o((!(element == null) ? isInterface(element, MutableEntry()) : false) ? element : THROW_CCE());
      }
      p1() {
        return new (CaseInsensitiveMap$EntrySet$iterator$1())(this.u4o_1);
      }
    }
    initMetadataForClass($, 'EntrySet');
    EntrySetClass = $;
  }
  return EntrySetClass;
}
var MapEntryClass;
function MapEntry() {
  if (MapEntryClass === VOID) {
    class $ {
      constructor($outer, key, _value) {
        this.z4o_1 = $outer;
        this.x4o_1 = key;
        this.y4o_1 = _value;
      }
      m3() {
        return this.x4o_1;
      }
      n3() {
        return this.y4o_1;
      }
      equals(other) {
        if (!(!(other == null) ? isInterface(other, Entry()) : false))
          return false;
        return equals_0(this.x4o_1, other.m3()) && equals_0(this.n3(), other.n3());
      }
      hashCode() {
        return getStringHashCode(this.x4o_1) ^ hashCode(this.n3());
      }
      toString() {
        return this.x4o_1 + '=' + toString_0(this.n3());
      }
    }
    initMetadataForClass($, 'MapEntry', VOID, VOID, [MutableEntry()]);
    MapEntryClass = $;
  }
  return MapEntryClass;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        this.a4p_1 = 8;
        var tmp = this;
        // Inline function 'kotlin.emptyArray' call
        tmp.b4p_1 = [];
        var tmp_0 = this;
        // Inline function 'kotlin.emptyArray' call
        tmp_0.c4p_1 = [];
        this.d4p_1 = new Int32Array(0);
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
var CaseInsensitiveMapClass;
function CaseInsensitiveMap() {
  if (CaseInsensitiveMapClass === VOID) {
    class $ {
      constructor() {
        Companion_getInstance();
        this.x4n_1 = Companion_getInstance().b4p_1;
        this.y4n_1 = Companion_getInstance().c4p_1;
        this.z4n_1 = 0;
        this.a4o_1 = Companion_getInstance().d4p_1;
        this.b4o_1 = 0;
        this.c4o_1 = null;
        this.d4o_1 = null;
        this.e4o_1 = null;
      }
      q2() {
        return this.z4n_1;
      }
      u2o(key) {
        return findIndex(this, key) >= 0;
      }
      s4(key) {
        if (!(!(key == null) ? typeof key === 'string' : false))
          return false;
        return this.u2o((!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE());
      }
      v2o(key) {
        var index = findIndex(this, key);
        return index >= 0 ? this.y4n_1[index] : null;
      }
      u4(key) {
        if (!(!(key == null) ? typeof key === 'string' : false))
          return null;
        return this.v2o((!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE());
      }
      n1() {
        return this.z4n_1 === 0;
      }
      a5() {
        if (this.z4n_1 > 0) {
          fill(this.x4n_1, null);
          fill(this.y4n_1, null);
          fill_0(this.a4o_1, -1);
          this.z4n_1 = 0;
          this.b4o_1 = 0;
        }
      }
      m4o(key, value) {
        if (this.x4n_1 === Companion_getInstance().b4p_1) {
          var tmp = this;
          // Inline function 'kotlin.arrayOfNulls' call
          tmp.x4n_1 = Array(8);
          var tmp_0 = this;
          // Inline function 'kotlin.arrayOfNulls' call
          tmp_0.y4n_1 = Array(8);
          var tmp_1 = this;
          var tmp_2 = 0;
          var tmp_3 = new Int32Array(8);
          while (tmp_2 < 8) {
            tmp_3[tmp_2] = -1;
            tmp_2 = tmp_2 + 1 | 0;
          }
          tmp_1.a4o_1 = tmp_3;
        }
        var hash = caseInsensitiveHashCode(Companion_getInstance(), key);
        var index = hash & (this.x4n_1.length - 1 | 0);
        while (true) {
          var existingKey = this.x4n_1[index];
          if (existingKey == null) {
            ensureCapacity(this);
            index = hash & (this.x4n_1.length - 1 | 0);
            while (!(this.x4n_1[index] == null)) {
              index = (index + 1 | 0) & (this.x4n_1.length - 1 | 0);
            }
            if (this.b4o_1 === this.a4o_1.length) {
              compactInsertionOrder(this);
            }
            this.x4n_1[index] = key;
            this.y4n_1[index] = value;
            var tmp_4 = this.a4o_1;
            var _unary__edvuaz = this.b4o_1;
            this.b4o_1 = _unary__edvuaz + 1 | 0;
            tmp_4[_unary__edvuaz] = index;
            this.z4n_1 = this.z4n_1 + 1 | 0;
            return null;
          }
          if (equals(existingKey, key, true)) {
            var oldValue = this.y4n_1[index];
            this.y4n_1[index] = value;
            return oldValue;
          }
          index = (index + 1 | 0) & (this.x4n_1.length - 1 | 0);
        }
      }
      x4(key, value) {
        var tmp = (!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE();
        return this.m4o(tmp, !(value == null) ? value : THROW_CCE());
      }
      e4p(from) {
        // Inline function 'kotlin.collections.forEach' call
        // Inline function 'kotlin.collections.iterator' call
        var _iterator__ex2g4s = from.l3().p1();
        while (_iterator__ex2g4s.q1()) {
          var element = _iterator__ex2g4s.r1();
          // Inline function 'kotlin.collections.component1' call
          var key = element.m3();
          // Inline function 'kotlin.collections.component2' call
          var value = element.n3();
          this.m4o(key, value);
        }
      }
      z4(from) {
        return this.e4p(from);
      }
      f4o(key) {
        var index = findIndex(this, key);
        if (index < 0)
          return null;
        var oldValue = this.y4n_1[index];
        var inductionVariable = 0;
        var last = this.b4o_1;
        if (inductionVariable < last)
          $l$loop: do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            if (this.a4o_1[i] === index) {
              this.a4o_1[i] = -1;
              break $l$loop;
            }
          }
           while (inductionVariable < last);
        this.x4n_1[index] = null;
        this.y4n_1[index] = null;
        this.z4n_1 = this.z4n_1 - 1 | 0;
        var nextIndex = (index + 1 | 0) & (this.x4n_1.length - 1 | 0);
        while (!(this.x4n_1[nextIndex] == null)) {
          var rehashKey = ensureNotNull(this.x4n_1[nextIndex]);
          var rehashValue = this.y4n_1[nextIndex];
          var oldRehashIndex = nextIndex;
          this.x4n_1[nextIndex] = null;
          this.y4n_1[nextIndex] = null;
          this.z4n_1 = this.z4n_1 - 1 | 0;
          var newIndex = putWithoutTrackingOrderReturnIndex(this, rehashKey, !(rehashValue == null) ? rehashValue : THROW_CCE());
          var inductionVariable_0 = 0;
          var last_0 = this.b4o_1;
          if (inductionVariable_0 < last_0)
            $l$loop_0: do {
              var i_0 = inductionVariable_0;
              inductionVariable_0 = inductionVariable_0 + 1 | 0;
              if (this.a4o_1[i_0] === oldRehashIndex) {
                this.a4o_1[i_0] = newIndex;
                break $l$loop_0;
              }
            }
             while (inductionVariable_0 < last_0);
          nextIndex = (nextIndex + 1 | 0) & (this.x4n_1.length - 1 | 0);
        }
        return oldValue;
      }
      y4(key) {
        if (!(!(key == null) ? typeof key === 'string' : false))
          return null;
        return this.f4o((!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE());
      }
      v4() {
        var tmp0_elvis_lhs = this.c4o_1;
        var tmp;
        if (tmp0_elvis_lhs == null) {
          // Inline function 'kotlin.also' call
          var this_0 = KeySet().o4o(this);
          this.c4o_1 = this_0;
          tmp = this_0;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        return tmp;
      }
      l3() {
        var tmp0_elvis_lhs = this.d4o_1;
        var tmp;
        if (tmp0_elvis_lhs == null) {
          // Inline function 'kotlin.also' call
          var this_0 = EntrySet().v4o(this);
          this.d4o_1 = this_0;
          tmp = this_0;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        return tmp;
      }
      w4() {
        var tmp0_elvis_lhs = this.e4o_1;
        var tmp;
        if (tmp0_elvis_lhs == null) {
          // Inline function 'kotlin.also' call
          var this_0 = ValueCollection().s4o(this);
          this.e4o_1 = this_0;
          tmp = this_0;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        return tmp;
      }
      equals(other) {
        if (other === this)
          return true;
        if (!(other instanceof CaseInsensitiveMap()))
          return false;
        if (!(other.q2() === this.z4n_1))
          return false;
        var inductionVariable = 0;
        var last = this.x4n_1.length - 1 | 0;
        if (inductionVariable <= last)
          do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var k = this.x4n_1[i];
            if (!(k == null)) {
              var v = this.y4n_1[i];
              if (!equals_0(other.v2o(k), v))
                return false;
            }
          }
           while (inductionVariable <= last);
        return true;
      }
      hashCode() {
        var result = 0;
        var inductionVariable = 0;
        var last = this.x4n_1.length - 1 | 0;
        if (inductionVariable <= last)
          do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var k = this.x4n_1[i];
            if (!(k == null)) {
              var tmp = result;
              var tmp_0 = caseInsensitiveHashCode(Companion_getInstance(), k);
              var tmp0_safe_receiver = this.y4n_1[i];
              var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
              result = tmp + (tmp_0 ^ (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs)) | 0;
            }
          }
           while (inductionVariable <= last);
        return result;
      }
    }
    initMetadataForClass($, 'CaseInsensitiveMap', CaseInsensitiveMap, VOID, [KtMutableMap()]);
    CaseInsensitiveMapClass = $;
  }
  return CaseInsensitiveMapClass;
}
//region block: exports
export {
  CaseInsensitiveMap as CaseInsensitiveMap3bv985x2xrppt,
};
//endregion

//# sourceMappingURL=CaseInsensitiveMap.mjs.map
